import { z } from 'zod';

import { ChildGenderEnum } from '../dotcom/children/childUtilityInterfaces';
import {
  LeadChurch,
  LeadContact,
  LeadEvent,
  LeadHost,
} from '../dotcom/proxy-api/leads';
import { NavigationProps } from './schema';

export const HeaderProps = z.object({
  primaryMenu: NavigationProps,
});
export type HeaderProps = z.infer<typeof HeaderProps>;

export const FooterProps = z.object({
  footerMenuPrimary: NavigationProps,
  footerMenuSecondary: NavigationProps,
  footerMenuSocial: NavigationProps.optional(),
  footerMenuTrust: NavigationProps.optional(),
});

export type FooterProps = z.infer<typeof FooterProps>;

/** Forms * */
const SubscriptionRequest = z.object({
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  subscriptionCode: z.string().optional(),
  isFirstNameRequired: z.boolean().optional(),
  isLastNameRequired: z.boolean().optional(),
});
export type SubscriptionRequest = z.infer<typeof SubscriptionRequest>;

const LeadBase = z.object({
  leadType: z.string().optional(),
});

const LeadChurchRequest = LeadBase.merge(LeadContact).merge(LeadChurch);
export type LeadChurchRequest = z.infer<typeof LeadChurchRequest>;

const LeadEventRequest = LeadBase.merge(LeadHost).merge(LeadEvent);
export type LeadEventRequest = z.infer<typeof LeadEventRequest>;

/** Compassion Sunday * */
export const CompassionSundayBaseFormData = LeadBase.merge(LeadHost);
export type CompassionSundayBaseFormData = z.infer<
  typeof CompassionSundayBaseFormData
>;

export const CompassionSundayRegistrationFormData =
  LeadBase.merge(LeadEvent).merge(LeadHost);
export type CompassionSundayRegistrationFormData = z.infer<
  typeof CompassionSundayRegistrationFormData
>;

/** SAC * */
export const ChildDetailsSchema = z.object({
  age: z.number(),
  birthDate: z.string(),
  holdExpirationDate: z.string().nullable(),
  fieldOffice: z.string(),
  gender: z.enum([ChildGenderEnum.Female, ChildGenderEnum.Male]),
  globalId: z.string(),
  holdingGlobalPartnerId: z.string().nullable(),
  icp: z.object({
    country: z.string(),
    id: z.string(),
  }),
  imageUrl: z.string(),
  isInHivAffectedArea: z.boolean(),
  isOrphan: z.boolean(),
  isSpecialNeeds: z.boolean(),
  localId: z.string(),
  minDaysWaiting: z.number(),
  name: z.object({
    first: z.string(),
    preferred: z.string(),
  }),
  priorityScore: z.number(),
  state: z.string(),
  sourceCode: z.string().nullable(),
  waitingSinceDate: z.string(),
});

export const ChildAvailabilitySearchResultsSchema = z.object({
  children: z.array(ChildDetailsSchema),
});
